/**
 * 작성자 : 박승호
 * 날짜 : 2025.04.25
 * 기능 : 로딩 전체화면 컴포넌트
 */

import { useTranslation } from 'react-i18next';
import { BounceLoader, PulseLoader } from 'react-spinners';
import styled from 'styled-components';

const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
  z-index: 5000;

  > .loading-cont {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1.5rem;

    > span {
      color: var(--text-primary);
    }
  }
`;

type Props = {
  type: 'bounce' | 'pulse';
  text?: string;
  color?: string;
  size?: number;
};

const FullScreenLoading = ({ type = 'pulse', text, color = 'var(--primary)', size = 60 }: Props) => {
  const { t } = useTranslation();

  return (
    <Root>
      <div className='loading-cont'>
        {type === 'bounce' && <BounceLoader color={color} size={size} />}
        {type === 'pulse' && <PulseLoader color={color} size={size} />}

        {text && <span>{t(text)}</span>}
      </div>
    </Root>
  );
};

export default FullScreenLoading;
